import { cn } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_TEXT } from '../lib/docStyles';

const DocNoteBox = ({ children, className }) => (
  <DocText
    size="xs"
    className={cn(
      DOC_TEXT.note,
      'rounded-lg border border-solid border-neutral-300 bg-neutral-100 px-3.5 py-2',
      className
    )}>
    {children}
  </DocText>
);

export default DocNoteBox;
